'use client'

import { cn } from '../../utils/cn'

interface VanMooseLogoProps {
  size?: number
  className?: string
  showText?: boolean
}

export function VanMooseLogo({ size = 24, className, showText = false }: VanMooseLogoProps) {
  return (
    <div className={cn('inline-flex items-center gap-2', className)}>
      <img
        src="/vanmoose-logo.png"
        alt="Van Moose"
        width={size}
        height={size}
        className="rounded-full"
      />

      {showText && (
        <span className="text-sm font-medium text-[var(--landing-text-muted)]">
          Van Moose
        </span>
      )}
    </div>
  )
}
